import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface IUserRegisterForm {
  fullName: string;
  email: string;
  password: string;
  locale: string;
}

@Component({
  standalone: false,
  selector: 'register-private-account-form',
  templateUrl: './register-private-account-form.component.html',
  styleUrls: ['./register-private-account-form.component.scss']
})
export class RegisterPrivateAccountFormComponent {
  @Input() error: string = '';
  @Input() countryCode: string;
  @Output() onSubmit = new EventEmitter<IUserRegisterForm>();

  public subscribedOnNews: boolean = false;

  public userForm: FormGroup;
  public showPassword = false;

  constructor(private _fb: FormBuilder) {
    this.userForm = this._fb.group({
      fullName: ['', [Validators.required, Validators.maxLength(32)]],
      email: ['', [Validators.email, Validators.required, Validators.maxLength(128)]],
      password: ['', [Validators.required, Validators.maxLength(32)]],
    });
  }

  public submit() {
    const model = this.userForm.value;
    const domainName = this.countryCode.toLowerCase();
    const domainLocaleMap = {
      'no': 'nb_NO',
      'se': 'sv_SE',
    };

    model.locale = domainLocaleMap[domainName] || 'nb_NO';
    model.subscribedOnNews = this.subscribedOnNews;

    this.onSubmit.emit(model);
  }
}
